module.exports = __webpack_public_path__ + "static/media/bat6.916a56b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat6.png
// module id = 474
// module chunks = 0